<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    :items-per-page="itemsPerPage"
    @page-count="pageCount = $event"
    :loading="loading"
    :page.sync="page"
    item-key="id"
    hide-default-footer
    hide-default-header
  >
    <template v-slot:header="{ props: { headers } }">
      <thead class="header">
        <tr>
          <th v-for="header in headers" :key="header.text" class="header--text">
            {{ header.text }}
          </th>
        </tr>
      </thead>
    </template>

    <template v-slot:item="{ index, item }">
      <tr>
        <td>{{ index + 1 }}</td>
        <td>{{ item.dots_startdate }}</td>
        <td>{{ item.dots_enddate }}</td>
        <td v-if="item.volunteer">
          {{ item.volunteer.name }} ({{ item.volunteer.code }})
        </td>
        <td v-else></td>
        <td>
          <span v-if="item.dots_app_status == 1">No</span>
          <span v-if="item.dots_app_status == 2">Yes</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["datas"],
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    headers: [
      { text: "No", value: "no" },
      { text: "DOT Start Date", value: "dots_start_date" },
      { text: "DOT End Date", value: "dots_end_date" },
      { text: "Volunteer", value: "volunteer" },
      { text: "Use App", value: "use_app" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
};
</script>

<style></style>
